import { render, staticRenderFns } from "./treePopagent.vue?vue&type=template&id=678fb6c5&scoped=true"
import script from "./treePopagent.vue?vue&type=script&lang=js"
export * from "./treePopagent.vue?vue&type=script&lang=js"
import style0 from "./treePopagent.vue?vue&type=style&index=0&id=678fb6c5&prod&lang=less&scoped=true"
import style1 from "./treePopagent.vue?vue&type=style&index=1&id=678fb6c5&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678fb6c5",
  null
  
)

export default component.exports